//@ts-check
import {Modal, Text, Toggle} from '@/components-v2'
import {SegmentGroup} from '@/features/Segments/SegmentGroup'
import {SegmentModal} from '@/features/Segments/SegmentModal'
import {useProductComboSegments} from '@/hooks/productCombo/useProductComboSegments'
import {useState} from 'react'

const defaultSegmentModalState = {
  show: false,
  type: '',
  isInclude: false,
}

export const ComboSegmentSection = () => {
  const {
    segmentConfiguration,
    isAllCustomers,
    isExcludeEnabled,
    handleRemoveRequest,
    toggleResetKey,
    showConfirmationModal,
    handleSegmentSubmissionRequest,
    handleAllCustomersToggleRequest,
    handleExcludeToggleRequest,
    handleConfirmPendingChange,
    handleCancelPendingChange,
  } = useProductComboSegments()
  const [segmentModalState, setSegmentModalState] = useState(defaultSegmentModalState)

  const handleSegmentSelection = (items, isInclude) => {
    const type = items?.[0]?.id
    if (!type) {
      return
    }
    setSegmentModalState({
      show: true,
      type,
      isInclude,
    })
  }

  const handleCloseSegmentModal = () => {
    setSegmentModalState(defaultSegmentModalState)
  }

  const handleSegmentSubmission = (selectedSegments, _groupIndex, type) => {
    handleSegmentSubmissionRequest(selectedSegments, type)
    handleCloseSegmentModal()
  }

  const includedSegmentGroup = segmentConfiguration?.includedSegments?.[0] ?? null

  const existingSelection = isExcludeEnabled
    ? segmentConfiguration?.excludedSegment?.segments
    : includedSegmentGroup?.segments

  return (
    <>
      <Text variant="bold">Segments</Text>
      <Toggle
        key={`all-customers-${toggleResetKey}`}
        onUpdate={handleAllCustomersToggleRequest}
        checked={isAllCustomers}
        size="medium"
        label="All Customers"
      />
      {!isAllCustomers && (
        <SegmentGroup
          key={`included-segments-${toggleResetKey}`}
          groupIndex={null}
          segmentGroup={includedSegmentGroup}
          onSegmentSelection={items => handleSegmentSelection(items, true)}
          handleRemove={handleRemoveRequest}
          tagsSeparator="OR"
          dropdownLabel={'Segments *'}
        />
      )}
      <div className="h-px bg-[var(--secondary-800)]" />
      <Toggle
        key={`exclude-${toggleResetKey}`}
        disabled={!isAllCustomers}
        onUpdate={handleExcludeToggleRequest}
        checked={isExcludeEnabled}
        size="medium"
        label="Exclude"
      />
      {isExcludeEnabled && (
        <SegmentGroup
          key={`excluded-segments-${toggleResetKey}`}
          groupIndex={null}
          segmentGroup={segmentConfiguration?.excludedSegment}
          onSegmentSelection={items => handleSegmentSelection(items, false)}
          handleRemove={handleRemoveRequest}
          tagsSeparator="OR"
        />
      )}
      <SegmentModal
        key={`segment-modal-${segmentModalState.show}-${segmentModalState.type}`}
        show={segmentModalState.show}
        type={segmentModalState.type}
        groupIndex={segmentModalState.groupIndex}
        existingSelections={existingSelection ?? []}
        onSubmit={handleSegmentSubmission}
        onClose={handleCloseSegmentModal}
      />
      <Modal
        showModal={showConfirmationModal}
        title={'Changing the Customer Segment will reset the Product List'}
        text={
          'If you change the customer segment, the current product list in this combo will be cleared. Do you want to continue?'
        }
        showPrimaryButton
        primaryButtonProps={{text: 'Continue', onClick: handleConfirmPendingChange}}
        showTertiaryButton={true}
        tertiaryButtonProps={{text: 'Cancel', onClick: handleCancelPendingChange}}
        className="min-h-80"
        onCloseModal={handleCancelPendingChange}
        hideCloseButton={true}
      />
    </>
  )
}
